const PFAND_VARIANT_ID = 58414443004239;
const PFAND_PRODUCT_HANDLE = 'ruckerstattbarer-shisha-pfand';

const originalFetch = window.fetch.bind(window);
let pfandSyncAktiv = false;
let interneAnfrage = false;

function istCartUrl(url, action) {
  return url.includes(`/cart/${action}`) || url.includes(`/cart/${action}.js`);
}

function leseArtikel(body) {
  try {
    if (body instanceof FormData || body instanceof URLSearchParams) {
      return [{
        id: Number(body.get('id')),
        quantity: Math.max(1, Number(body.get('quantity') || 1)),
      }];
    }

    if (typeof body === 'string') {
      const data = JSON.parse(body);

      if (Array.isArray(data.items)) {
        return data.items.map((item) => ({
          id: Number(item.id),
          quantity: Math.max(1, Number(item.quantity || 1)),
        }));
      }

      return [{
        id: Number(data.id),
        quantity: Math.max(1, Number(data.quantity || 1)),
      }];
    }
  } catch (error) {
    console.warn('Warenkorbdaten konnten nicht gelesen werden:', error);
  }

  return [];
}

async function cartLaden() {
  const root = window.Shopify?.routes?.root || '/';
  const response = await originalFetch(`${root}cart.js`, {
    headers: { Accept: 'application/json' },
  });

  if (!response.ok) {
    throw new Error('Warenkorb konnte nicht geladen werden.');
  }

  return response.json();
}

async function pfandSynchronisieren() {
  if (pfandSyncAktiv) return;

  pfandSyncAktiv = true;

  try {
    const cart = await cartLaden();

    const pfandArtikel = cart.items.find(
      (item) => Number(item.variant_id) === PFAND_VARIANT_ID
    );

    /*
      Alle Artikel außer dem Pfand zählen momentan als Shisha.
      Extra-Köpfe, Getränke und Zubehör müssen später ausgeschlossen werden.
    */
    const benoetigtePfandMenge = cart.items
      .filter((item) => Number(item.variant_id) !== PFAND_VARIANT_ID)
      .reduce((sum, item) => sum + Number(item.quantity || 0), 0);

    const vorhandenePfandMenge = Number(pfandArtikel?.quantity || 0);

    if (benoetigtePfandMenge === vorhandenePfandMenge) return;

    const root = window.Shopify?.routes?.root || '/';
    interneAnfrage = true;

    if (pfandArtikel) {
      await originalFetch(`${root}cart/change.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          id: pfandArtikel.key,
          quantity: benoetigtePfandMenge,
        }),
      });
    } else if (benoetigtePfandMenge > 0) {
      await originalFetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          items: [{
            id: PFAND_VARIANT_ID,
            quantity: benoetigtePfandMenge,
            properties: {
              _Hinweis: 'Nach Rückgabe vollständig rückerstattbar',
            },
          }],
        }),
      });
    }

    window.location.reload();
  } catch (error) {
    console.error('Pfand konnte nicht synchronisiert werden:', error);
  } finally {
    interneAnfrage = false;
    pfandSyncAktiv = false;
  }
}

window.fetch = async function (input, options = {}) {
  const url =
    typeof input === 'string'
      ? input
      : input instanceof Request
        ? input.url
        : '';

  const method = (
    options.method ||
    (input instanceof Request ? input.method : 'GET')
  ).toUpperCase();

  if (interneAnfrage || method !== 'POST') {
    return originalFetch(input, options);
  }

  const istHinzufuegen = istCartUrl(url, 'add');
  const istAenderung =
    istCartUrl(url, 'change') ||
    istCartUrl(url, 'update') ||
    istCartUrl(url, 'clear');

  if (istHinzufuegen) {
    const artikel = leseArtikel(options.body);
    const normaleArtikel = artikel.filter(
      (item) => item.id && item.id !== PFAND_VARIANT_ID
    );

    const response = await originalFetch(input, options);

    if (!response.ok || normaleArtikel.length === 0) {
      return response;
    }

    const pfandMenge = normaleArtikel.reduce(
      (sum, item) => sum + item.quantity,
      0
    );

    interneAnfrage = true;

    try {
      const root = window.Shopify?.routes?.root || '/';

      await originalFetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          items: [{
            id: PFAND_VARIANT_ID,
            quantity: pfandMenge,
            properties: {
              _Hinweis: 'Nach Rückgabe vollständig rückerstattbar',
            },
          }],
        }),
      });

      window.location.href = `${root}cart`;
    } finally {
      interneAnfrage = false;
    }

    return response;
  }

  const response = await originalFetch(input, options);

  if (response.ok && istAenderung) {
    setTimeout(pfandSynchronisieren, 300);
  }

  return response;
};

document.addEventListener('DOMContentLoaded', () => {
  if (window.location.pathname.includes('/cart')) {
    setTimeout(pfandSynchronisieren, 500);
  }
});
const CHECKOUT_SELECTOR =
  'button[name="checkout"], input[name="checkout"], a[href*="/checkout"], [data-checkout]';

async function pruefePfandVorCheckout(event) {
  const checkoutButton = event.target.closest?.(CHECKOUT_SELECTOR);
  if (!checkoutButton) return;

  event.preventDefault();
  event.stopImmediatePropagation();

  checkoutButton.disabled = true;
  checkoutButton.setAttribute('aria-busy', 'true');

  try {
    await pfandSynchronisieren();

    const cart = await cartLaden();

    const normaleMenge = cart.items
      .filter((item) => Number(item.variant_id) !== PFAND_VARIANT_ID)
      .reduce((sum, item) => sum + Number(item.quantity || 0), 0);

    const pfandMenge = cart.items
      .filter((item) => Number(item.variant_id) === PFAND_VARIANT_ID)
      .reduce((sum, item) => sum + Number(item.quantity || 0), 0);

    if (normaleMenge !== pfandMenge) {
      alert('Der rückerstattbare Pfand wird gerade hinzugefügt. Bitte kurz warten.');
      window.location.reload();
      return;
    }

    window.location.href = '/checkout';
  } catch (error) {
    console.error('Checkout-Prüfung fehlgeschlagen:', error);
    alert('Der Pfand konnte nicht geprüft werden. Bitte versuche es erneut.');
  } finally {
    checkoutButton.disabled = false;
    checkoutButton.removeAttribute('aria-busy');
  }
}
document.addEventListener('click', pruefePfandVorCheckout, true);

document.addEventListener(
  'submit',
  async (event) => {
    const form = event.target;

    if (!(form instanceof HTMLFormElement)) return;
    if (!form.action.includes('/cart')) return;
    if (!form.querySelector('[name="checkout"]')) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    await pruefePfandVorCheckout({
      target: form.querySelector('[name="checkout"]'),
      preventDefault() {},
      stopImmediatePropagation() {},
    });
  },
  true
);